<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import PdpBundlePromoTile from '../../product-details/components/PdpBundlePromotion/PdpBundlePromoTile.svelte';

  export let index;
  export let data;
  const dispatcher = createEventDispatcher();
  console.log(data, 'data');
  function onBundleClick(data) {
    dispatcher('click', data);
  }
</script>

<PdpBundlePromoTile specialOfferDataList={data} {index} on:bundleClickedTile={data => onBundleClick(data.detail)} />
